module.exports = __webpack_public_path__ + "static/illustration-30a61330c970face5d90e728f86aa97d.svg";